import {
  CONTACT_TYPE,
  PERSON_TYPE,
  TYPE_CNPJ,
  TYPE_CPF
} from "@hub/offline-order/src/constants"
import { convertDateEnToPtBR } from "@shared/helpers"

const fillIndividualData = (commit, client, isOffline) => {
  commit("setDocument", client.document || "")
  commit("setType", TYPE_CPF)
  commit("setRG", client.general_registration || "")
  commit("setName", client.name || "")
  commit("setBirthDate", convertDateEnToPtBR(client.birthdate) || "")
  commit("setMotherName", client.mother_name || "")
  commit("setFatherName", client.father_name || "")
  commit("setGender", client.gender || "")
  commit("setSchooled", client.schooled || "")
  commit("setMaritalStatus", client.marital_status || "")
  commit("setProfession", client.profession || "")
  commit("setNote", isOffline ? client.note || "" : client.observation || "")
}

const fillLegalData = (commit, client, isOffline) => {
  commit("setDocument", client.document || "")
  commit("setType", TYPE_CNPJ)
  commit("setCompanyName", client.social_reason || "")
  commit(
    "setCompanyType",
    isOffline ? client.person_legal_type || "" : client.legal_type || ""
  )
  commit("setOpeningDate", convertDateEnToPtBR(client.opening_date) || "")
  commit("setResponsibleName", client.responsible?.name || "")
  commit("setResponsibleCpf", client.responsible?.cpf || "")
  commit("setStateRegistration", client.state_registration || "")
  commit("setNote", isOffline ? client.note || "" : client.observation || "")
}

const findContact = (contacts, type) => {
  return contacts.find(contact => contact.type === type)
}

const fillContactData = (commit, contacts) => {
  const email = findContact(contacts, CONTACT_TYPE.EMAIL)
  commit("setEmail", email?.value || "")

  const cellphone = findContact(contacts, CONTACT_TYPE.CELLPHONE)
  commit("setCellphone", cellphone?.value || "")

  const landline = findContact(contacts, CONTACT_TYPE.LANDLINE)
  commit("setLandline", landline?.value || "")

  const anotherContact = findContact(contacts, CONTACT_TYPE.ANOTHER_CONTACT)
  commit("setAnotherContact", anotherContact?.value || "")
}

const fillClientData = (commit, client, isOffline) => {
  if (
    client.person_type === PERSON_TYPE.INDIVIDUAL ||
    client.type === PERSON_TYPE.INDIVIDUAL
  ) {
    fillIndividualData(commit, isOffline ? client.physical : client, isOffline)
  } else if (
    client.person_type === PERSON_TYPE.LEGAL ||
    client.type === PERSON_TYPE.LEGAL
  ) {
    fillLegalData(commit, isOffline ? client.legal : client, isOffline)
  }

  fillContactData(commit, client.contacts)
}

export default {
  fillOfflineClient({ commit }, client) {
    fillClientData(commit, client, true)
  },

  fillClient({ commit }, client) {
    fillClientData(commit, client, false)
  }
}
